module.exports = __webpack_public_path__ + "media/images/icon__live@3x-995441a577fc03e6b236e39e01af2cd4.png";